import { render, staticRenderFns } from "./bankModalArchiveAccount.vue?vue&type=template&id=313ba368&scoped=true"
import script from "./bankModalArchiveAccount.vue?vue&type=script&lang=js"
export * from "./bankModalArchiveAccount.vue?vue&type=script&lang=js"
import style0 from "./bankModalArchiveAccount.vue?vue&type=style&index=0&id=313ba368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ba368",
  null
  
)

export default component.exports